import {Component, Input, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {faTrash} from "@fortawesome/free-solid-svg-icons/faTrash";
import {faCheck} from "@fortawesome/free-solid-svg-icons/faCheck";
import {faFilter} from "@fortawesome/free-solid-svg-icons/faFilter";
import {faSearch} from "@fortawesome/free-solid-svg-icons/faSearch";
import {faTimesCircle} from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import {faLockOpen} from "@fortawesome/free-solid-svg-icons/faLockOpen";
import {faLock} from "@fortawesome/free-solid-svg-icons/faLock";
import {ListTypeInfo} from "@amlRegistries/components";
import {RegistriesService} from "../../service";
import {VisitedService} from "@amlCore/services";
import {VisitedLinkModel} from "@amlCore/models";
import {ClientTypeEnum} from '@amlCore/enums';
import {InternalModel} from "../../model";
import {InternalService} from "../internalList/internal.service";
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {TerroristViewComponent} from '../terrorists';
import {MvkComponent} from '../mvkList';
import {BounceRegisterComponent} from '../bounceRegisterList';
import {InternalViewComponent} from '../internalList/internal';
import {ConsolidatedComponent} from '../consolidatedList/consolidated';

@Component({
  selector: 'app-table-layaut',
  templateUrl: './table-layaut.component.html'
})
export class TableLayautComponent implements OnInit {

  @Input() listTypeVal: ListTypeInfo;
  @Input() clientType: ClientTypeEnum;

  clientTypeEnum = ClientTypeEnum;
  isFL: boolean = false;
  public icons = {
    trash: faTrash,
    check: faCheck,
    filter: faFilter,
    search: faSearch,
    circle: faTimesCircle,
    unlocked: faLockOpen,
    locked: faLock
  };

  private readonly _titles = {
    consolidated: ConsolidatedComponent,
    terroristView: TerroristViewComponent,
    mvk: MvkComponent,
    bounceRegister: BounceRegisterComponent,
    internalView: InternalViewComponent,
  }

  private readonly _MODAL_CONFIG = {
    size: "lg",
    backdrop: "static",
    centered: true,
  } as NgbModalOptions;

  constructor(private regSrv: RegistriesService,
              protected visitedService: VisitedService,
              protected router: Router,
              protected internalService: InternalService,
              private readonly modalService: NgbModal) {
  }

  ngOnInit(): void {
    if (this.listTypeVal.list) {
      const keyId = this.listTypeVal.id === 'checkMvk' ? 'subjectId' : 'id';
      (this.listTypeVal.list as Array<VisitedLinkModel>).forEach(item => {
        if (this.visitedService.getVisitedId(item[keyId])) {
          item.$visited = true;
        }
      });
    }
    if (this.clientType) {
      this.isFL = [ClientTypeEnum.INDIVIDUAL_PERSON,
        ClientTypeEnum.INDIVIDUAL_ENTREPRENEUR,
        ClientTypeEnum.PRIVATE_PRACTITIONER
      ].includes(this.clientType);
    }
  }

  viewList(titleList: string, item: any) {
    const isMvk = titleList === 'mvk';
    const modal = this.modalService.open(this._titles[titleList], this._MODAL_CONFIG);
    const id = isMvk ? item.subjectId : item.id;
    const scrollItemId = titleList + '_' + item.id;
    
    if (item) {
      modal.componentInstance[isMvk ? 'subjectId' : 'id'] = id;
      modal.componentInstance.isModal = true;
      if (isMvk) modal.componentInstance.decisionId = item.decisionId;
    }

    item.$visited = true;
    this.visitedService.setVisitedId(id);
    this.regSrv.savedFilterSPK = {groupName: 'scroll', key: 'id', value: scrollItemId};
  }

  isClientType1_5(item: InternalModel): string {
    return [ClientTypeEnum.INDIVIDUAL_ENTREPRENEUR,
      ClientTypeEnum.INDIVIDUAL_PERSON,
      ClientTypeEnum.PRIVATE_PRACTITIONER
    ].includes(item.uchType) ? item.orgNameRu :
      [ClientTypeEnum.LEGAL_ENTITY,
        ClientTypeEnum.FOREIGN_STRUCTURE].includes(item.uchType) ? getName1_5() : '';

    // Для 1 и 5 выводится одно из "orgNameRu", "orgNameFullRu", "orgNameIn", "orgNameFullIn"
    function getName1_5(): string {
      return item.orgNameRu ? item.orgNameRu :
        item.orgNameFullRu ? item.orgNameFullRu :
          item.orgNameIn ? item.orgNameIn :
            item.orgNameFullIn ? item.orgNameFullIn : '';
    }
  }

  /**
   * Столбец "Наименование/ФИО"
   * @param item - строка
   */
  getName(item: InternalModel): string {
    return this.internalService.getName(item);
  }
  
  /**
   * Столбец "ИНН/Рег номер"
   * @param item - строка
   */
   getInnRegNumber(item: InternalModel): string {
     if(item.type === '5' ){
        return item.inboulNomers ? item.inboulNomers.join(', ') : '';
     }else{
        return item.inn;
     }
   }
}
